module.exports = __webpack_public_path__ + "img/Logo-Dgt-Rodape.a938fbe9.svg";